/* theme.js */
(function () {
  'use strict';

  /* ---- Mobile menu ---- */
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav = document.getElementById('mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', open);
      mobileNav.setAttribute('aria-hidden', !open);
    });
    document.addEventListener('click', e => {
      if (!menuBtn.contains(e.target) && !mobileNav.contains(e.target)) {
        mobileNav.classList.remove('is-open');
      }
    });
  }

  /* ---- Search toggle ---- */
  const searchBtn = document.querySelector('.search-toggle');
  const searchBar = document.getElementById('search-bar');
  if (searchBtn && searchBar) {
    searchBtn.addEventListener('click', () => {
      if (searchBar.hasAttribute('hidden')) {
        searchBar.removeAttribute('hidden');
        searchBar.querySelector('input')?.focus();
      } else {
        searchBar.setAttribute('hidden', '');
      }
    });
  }

  /* ---- Cart drawer ---- */
  const cartDrawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('overlay');

  function openCart() {
    cartDrawer?.classList.add('is-open');
    overlay?.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartDrawer?.classList.remove('is-open');
    overlay?.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.cart-toggle').forEach(b => b.addEventListener('click', openCart));
  document.querySelectorAll('.cart-close').forEach(b => b.addEventListener('click', closeCart));
  overlay?.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  /* Cart qty / remove */
  document.addEventListener('click', async e => {
    const qBtn = e.target.closest('.qty-ctrl .qty-btn');
    if (qBtn) {
      const key = qBtn.dataset.key;
      const action = qBtn.dataset.action;
      const item = qBtn.closest('.cart-item');
      const qVal = item?.querySelector('.qty-ctrl span');
      if (!qVal) return;
      const cur = parseInt(qVal.textContent, 10);
      const next = action === 'increase' ? cur + 1 : Math.max(0, cur - 1);
      await cartChange(key, next);
    }
    const rmBtn = e.target.closest('.cart-item__remove');
    if (rmBtn) await cartChange(rmBtn.dataset.key, 0);
  });

  async function cartChange(key, qty) {
    try {
      const r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
      const cart = await r.json();
      updateCartCount(cart.item_count);
      updateSubtotal(cart.total_price);
      refreshCartBody();
    } catch (e) { console.error(e); }
  }

  function updateCartCount(n) {
    document.querySelectorAll('#cart-count').forEach(el => {
      el.textContent = n;
      el.style.display = n ? '' : 'none';
    });
  }
  function updateSubtotal(cents) {
    const el = document.getElementById('cart-subtotal');
    if (el) el.textContent = formatMoney(cents);
  }
  async function refreshCartBody() {
    try {
      const r = await fetch('/?sections=cart-drawer');
      const d = await r.json();
      if (d['cart-drawer']) {
        const tmp = document.createElement('div');
        tmp.innerHTML = d['cart-drawer'];
        const nb = tmp.querySelector('.cart-drawer__body');
        const nf = tmp.querySelector('.cart-drawer__footer');
        const cb = document.querySelector('.cart-drawer__body');
        const cf = document.querySelector('.cart-drawer__footer');
        if (nb && cb) cb.innerHTML = nb.innerHTML;
        if (cf) { if (nf) cf.innerHTML = nf.innerHTML; else cf.remove(); }
      }
    } catch (e) { window.location.reload(); }
  }

  /* ---- Quick add ---- */
  document.addEventListener('click', async e => {
    const btn = e.target.closest('.btn-add-cart');
    if (!btn || btn.disabled) return;
    const vid = btn.dataset.variant;
    if (!vid) return;
    btn.textContent = 'Adding...';
    btn.disabled = true;
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) });
      const d = await r.json();
      if (d.status) throw new Error(d.description);
      btn.textContent = 'Added!';
      const cr = await fetch('/cart.js');
      const cart = await cr.json();
      updateCartCount(cart.item_count);
      updateSubtotal(cart.total_price);
      openCart();
      setTimeout(() => { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 2000);
    } catch (err) { btn.textContent = 'Try again'; btn.disabled = false; }
  });

  /* ---- Slideshow ---- */
  document.querySelectorAll('.hero-slideshow').forEach(sl => {
    const track = sl.querySelector('.slideshow-track');
    const slides = sl.querySelectorAll('.slide');
    const dots = sl.querySelectorAll('.dot');
    const prevBtn = sl.querySelector('.slide-arrow--prev');
    const nextBtn = sl.querySelector('.slide-arrow--next');
    if (!track || slides.length < 2) return;

    let cur = 0;
    let timer;
    const autoplay = sl.dataset.autoplay === 'true';
    const speed = parseInt(sl.dataset.speed) || 5000;

    // Set slide height from settings
    const firstSlide = slides[0];
    if (firstSlide) {
      const h = parseInt(firstSlide.closest('.hero-slideshow')?.style.getPropertyValue('--slide-height')) || null;
    }

    function go(idx) {
      slides[cur].classList.remove('is-active');
      dots[cur]?.classList.remove('is-active');
      cur = (idx + slides.length) % slides.length;
      slides[cur].classList.add('is-active');
      dots[cur]?.classList.add('is-active');
      track.style.transform = `translateX(-${cur * 100}%)`;
    }

    prevBtn?.addEventListener('click', () => { clearTimeout(timer); go(cur - 1); if (autoplay) startAuto(); });
    nextBtn?.addEventListener('click', () => { clearTimeout(timer); go(cur + 1); if (autoplay) startAuto(); });
    dots.forEach((d, i) => d.addEventListener('click', () => { clearTimeout(timer); go(i); if (autoplay) startAuto(); }));

    function startAuto() {
      timer = setInterval(() => go(cur + 1), speed);
    }
    if (autoplay) startAuto();

    // Swipe support
    let startX;
    track.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { clearTimeout(timer); go(dx < 0 ? cur + 1 : cur - 1); if (autoplay) startAuto(); }
    });
  });

  /* ---- Product scroll bar sync ---- */
  document.querySelectorAll('.product-scroll-track').forEach(track => {
    const fill = track.closest('.product-scroll-wrap')?.querySelector('.scroll-bar__fill');
    if (!fill) return;
    track.addEventListener('scroll', () => {
      const pct = track.scrollLeft / (track.scrollWidth - track.clientWidth);
      fill.style.transform = `translateX(${pct * (track.clientWidth - fill.clientWidth)}px)`;
    }, { passive: true });
  });

  /* ---- Utility ---- */
  function formatMoney(cents) {
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(cents / 100);
  }

})();
